import { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import SEO from '../content/seoMeta.json';

const SITE = 'https://www.enhancements.eu';


const setMeta = (selector, attr, value) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith('link') ? 'link' : 'meta');
    const [, key, name] = selector.match(/\[(\w+)="([^"]+)"\]/);
    el.setAttribute(key, name);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

export const useSeo = (page, path, jsonLd) => {
  const { language } = useLanguage();

  const { title, description } = typeof page === 'string' ? SEO[language][page] : page;

  useEffect(() => {
    const url = `${SITE}${path}`;
    document.title = title;
    document.documentElement.lang = language;
    setMeta('meta[name="title"]', 'content', title);
    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:url"]', 'content', url);
    setMeta('link[rel="canonical"]', 'href', url);

    if (!jsonLd) return undefined;
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);
    return () => script.remove();
  }, [language, title, description, path, jsonLd]);
};
